<template>
  <Table
    id="matrixTable"
    mode="records"
    :columns="columns"
    :rows="filteredList"
    :total-rows="filteredList.length"
    :filters="filters"
    :filterOptions="filterOptions"
    :isLoading="isLoading"
    :pagination-options="paginationOptions"
    sorting-enabled
    @column-filter="onColumnFilters"
    @filters-clear="resetFilters"
  >
    <template #actions="{customData}">
      <div class="flex justify-around">
        <EditButton
          :disabled="customData.disabled || disabled || !isEditAllowed"
          @click="$emit('edit', customData)"
        />
        <CloneButton
            :disabled="customData.disabled || disabled"
            @click="$emit('clone', customData)"
          />
        <ViewButton
          :disabled="customData.disabled || disabled"
          @click="$emit('view', customData)"
        />
        <!-- TODO -->
        <!-- <CloneButton
          :disabled="disabled"
          @click="$emit('clone', customData)"
        /> -->
        <DeleteButton
          :disabled="customData.disabled || disabled || !isEditAllowed"
          @click="$emit('delete', customData)"
        />
      </div>
    </template>
  </Table>
</template>

<script>
import Table from "@shared/dashboard-components/table-large";
import {
  CloneButton,
  EditButton,
  DeleteButton,
  ViewButton,
} from "@shared/components/icon-buttons";
import {
  getFilterOptions,
  getFilteredRows,
} from "@shared/dashboard-components/table-large/utils";
import { paginationOptions } from "@shared/dashboard-components/table-large/utils/constants";
import { checkPermission } from "@shared/utils/functions";

export default {
  components: {
    Table,
    CloneButton,
    EditButton,
    DeleteButton,
    ViewButton,
  },

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      filters: {},
      paginationOptions: { ...paginationOptions },
    }
  },

  computed: {
    isEditAllowed() {
      return checkPermission("wam.edit");
    },

    columns() {
      return [
        {
          field: "name",
          config: {
            filter: true,
            type: "tooltip_text"
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: this.$t("components.table.name"),
        },
        {
          field: "description",
          config: {
            filter: true,
            type: "tooltip_text"
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: this.$t("components.table.description"),
        },
        {
          field: "created_at",
          config: {
            filter: true,
            type: "source"
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: this.$t("components.table.created_at"),
        },
        {
          field: "modified_by",
          config: {
            filter: true,
            type: "tooltip_text"
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: this.$t("components.table.last_updated_by"),
        },
        {
          field: "modified_at",
          config: {
            filter: true,
            type: "source"
          },
          tdClass: "truncate max-w-sm",
          sortable: true,
          label: this.$t("components.table.last_updated_at"),
        },
        {
          field: "actions",
          config: { filter: false, type: "actions" },
          tdClass: "truncate max-w-xs",
          width: "140px",
          sortable: false,
          label: this.$t("components.table.action"),
        },
        ].filter(column =>  !column.hide);
    },
    filteredList() {
      return getFilteredRows(this.list, this.filters);
    },
    filterOptions() {
      return getFilterOptions(this.columns, this.list)
    },
  },

  methods: {
    onColumnFilters({ columnFilters }) {
      this.filters = columnFilters;
    },
    resetFilters() {
      this.filters = {};
    },
  }
}
</script>

<style lang="scss" scoped>

</style>